export default __webpack_public_path__ + "static/media/belts.18afe3c5.jpg";